import { SliderDropdownGroup as SliderDropdownGroupType } from '../../../../../../types/Survey/Element'
import { SliderDropdownGroup as SliderDropdownGroupAnswerType } from '../../../../../../types/Survey/Analysis/Element'
import { Props } from './types'
import Core from './Core'
import Pie, { Item as PieItem } from '../../../../../UI/Chart/Pie/Pie'
import Bar, { Item as BarItem } from '../../../../../UI/Chart/Bar/Bar'
import { ChartType } from './ChartSelector'
import { useState } from 'react'
import { round } from 'lodash'
import { useSelector } from 'react-redux'
import props from '../../../../../../redux/props'
import Modal from '../../../../../UI/Modal/Modal'
import Button from '../../../../../UI/Button/Button'

const SliderDropdownGroup: React.FC<Props<SliderDropdownGroupType, SliderDropdownGroupAnswerType>> = ({ element, analysisElement }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const [activeChart, setActiveChart] = useState(ChartType.PIE)
  const [show, setShow] = useState(false)
  const toggle = () => setShow(!show)

  const getPieChartItems = (): PieItem[] =>
    element.sliderDropdowns.reduce((acc, s) => {
      const analysisSlider = analysisElement.sliderDropdowns.find((slider) => slider.uuid === s.uuid)
      if (analysisSlider) {
        acc.push({
          value: round(analysisSlider.value.average, 2),
          label: `${s.title || element.title}`,
        })
      }
      return acc
    }, [])

  const getBarChartItems = (): BarItem[] =>
    element.sliderDropdowns.reduce((acc, s) => {
      const analysisSlider = analysisElement.sliderDropdowns.find((slider) => slider.uuid === s.uuid)
      if (analysisSlider) {
        acc.push({
          value: round(analysisSlider.value.average, 2),
          label: `${s.title || element.title}`,
        })
      }
      return acc
    }, [])

  const getOptions = () => {
    return element.sliderDropdowns.map((sliderDropdown) => {
      const analysisSliderDropdown = analysisElement.sliderDropdowns.find((slider) => slider.uuid === sliderDropdown.uuid)
      return {
        title: sliderDropdown.title,
        answerCount: analysisSliderDropdown.value.answers.length,
        average: analysisSliderDropdown.value.average,
        cluster: sliderDropdown.dropdownOptions.map((o) => ({
          title: o.value,
          value: analysisSliderDropdown.optionCluster[o.uuid].percentage,
        })),
      }
    })
  }

  const getOptionDropdownPieChartItems = (option: any) => {
    return option.cluster.map((c) => ({ value: round(c.value, 2), label: c.title }))
  }

  // const getOptionChartItems = (option: any) => {
  //   const value = round(option.average, 2)
  //   return [
  //     { value, label: option.title },
  //     { value: 100 - value, label: t.survey.analysis.averageValues.rest },
  //   ]
  // }

  return (
    <div>
      <Core element={element} availableChartOptions={[ChartType.PIE, ChartType.BAR]} activeChart={activeChart} setActiveChart={setActiveChart} />
      <div className="mt-5 flex justify-center">
        {activeChart === ChartType.PIE && (
          <div className="w-full">
            <Pie showLegend items={getPieChartItems()} enableDownload />
          </div>
        )}
        {activeChart === ChartType.BAR && <Bar enableDownload items={getBarChartItems()} />}
      </div>
      <Button small className="mt-3 ml-auto" text={t.survey.analysis.averageValues.sliderDropdownGroup.showDetail} onClick={toggle} />
      <Modal noForm show={show} onClose={toggle} title={element.title}>
        <div className="flex flex-col gap-10">
          {getOptions().map((o, i) => (
            <div key={i}>
              <div className="font-bold">{o.title}</div>
              {o.average ? (
                <div className="flex gap-3">
                  {/* <div className="w-1/2">
                    <div>{t.survey.analysis.averageValues.sliderDropdownGroup.average}</div>
                    <Pie showLegend items={getOptionChartItems(o)} enableDownload />
                  </div> */}
                  <div className="w-full">
                    <div>{t.survey.analysis.averageValues.sliderDropdownGroup.options}</div>
                    <Pie showLegend items={getOptionDropdownPieChartItems(o)} enableDownload />
                  </div>
                </div>
              ) : (
                <div>{t.survey.analysis.averageValues.noDataAvailable}</div>
              )}
              {/* <div>
              {o.cluster.map((c, i) => (
                <div key={i} className="flex justify-between">
                  <div className="text-sm">{c.title}</div>
                  <div className="text-sm">
                    {round(c.value, 2)}
                    {t.generic.percentageSuffix}
                  </div>
                </div>
              ))}
            </div> */}
            </div>
          ))}
        </div>
      </Modal>
    </div>
  )
}

export default SliderDropdownGroup
